import React, { useState } from "react";
import { IoChevronForward, IoClose, IoMenu, IoSearch } from "react-icons/io5";

const navLinks = [
  { href: "/products", label: "Products" },
  { href: "/services", label: "Services" },
  { href: "/about", label: "Who we are" },
  { href: "/contact", label: "Contact" },
  { href: "/values", label: "Values" },
];

const Header: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <>
      {/* Desktop Header */}
      <header className="font-oswald sticky top-0 z-50 bg-white hidden lg:block border-b border-gray-300">
        <div className="container mx-auto flex items-center justify-between py-4">
          <a href="/home" className="text-xl font-bold text-blue-800">
            NYIRENDAS HYDROXY METER
          </a>

          <nav>
            <ul className="flex space-x-8 font-poppins">
              {navLinks.map(({ href, label }) => (
                <li key={href} className="relative pb-2 hover:text-blue-600">
                  <a href={href} className="uppercase">
                    {label}
                  </a>
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full"></span>
                </li>
              ))}
            </ul>
          </nav>

          <div className="flex items-center space-x-6">
            {/* <button onClick={() => setSearchOpen(!searchOpen)}>
              <IoSearch className="h-6 w-6 text-gray-800" />
            </button> */}
            <a
              href="/contact"
              className="bg-blue-600 hover:bg-blue-800 text-white uppercase font-medium py-2 px-4 rounded transition"
            >
              Contact Us
            </a>
          </div>
        </div>

        {/* Search Overlay */}
        {/* {searchOpen && (
          <div className="absolute inset-x-0 top-full bg-white shadow p-4">
            <div className="container mx-auto flex items-center space-x-2">
              <IoSearch className="h-5 w-5 text-gray-600" />
              <input
                type="text"
                placeholder="Search"
                className="flex-grow bg-transparent outline-none"
              />
              <button onClick={() => setSearchOpen(false)}>
                <IoClose className="h-5 w-5 text-gray-600" />
              </button>
            </div>
          </div>
        )} */}
      </header>

      {/* Mobile Header */}
      <header className="font-oswald px-8 sticky top-0 z-50 bg-white lg:hidden border-b border-gray-300">
        <div className="container mx-auto flex items-center justify-between py-4">
          <a href="/home" className="text-lg font-bold text-blue-800">
            NYIRENDAS
          </a>
          <div className="flex items-center space-x-4">
            {/* <button onClick={() => setSearchOpen(!searchOpen)}>
              <IoSearch className="h-6 w-6 text-gray-800" />
            </button> */}
            <button onClick={() => setMobileOpen(true)} aria-label="Open menu">
              <IoMenu className="h-6 w-6 text-gray-800" />
            </button>
          </div>
        </div>

        {/* Mobile Fullscreen Nav */}
        <div
          className={`fixed inset-0 bg-white z-50 transform transition-transform duration-300 ease-in-out ${
            mobileOpen ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="container mx-auto py-6 flex justify-end">
            <button onClick={() => setMobileOpen(false)} aria-label="Close menu">
              <IoClose className="h-6 w-6 text-gray-800" />
            </button>
          </div>
          <nav className="container mx-auto flex flex-col space-y-6 items-center mt-8">
            {navLinks.map(({ href, label }) => (
              <a
                key={href}
                href={href}
                className="flex items-center uppercase text-xl font-medium hover:text-blue-600 transition"
              >
                {label}
                <IoChevronForward className="ml-2 h-5 w-5" />
              </a>
            ))}
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;
